export default __webpack_public_path__ + "static/reliance-574f1cdc6031adc8d67f65c731b321bb.jpg";